import { alpha } from '@mui/material';
var colors = {
  // Accent
  persianBlue: '#223CB1',
  royalBlue: '#425DD9',
  cornflowerBlue: '#5B78FB',
  titanWhite: '#E9ECFF',
  whiteLilac: '#F3F5FB',
  neonCarrot: '#FF9331',
  serenade: '#FFF0E2',
  jewel: '#14804A',
  oceanGreen: '#38A06C',
  scandal: '#E1FCEF',
  maroonFlush: '#CC234C',
  cabaret: '#DD4469',
  frenchRose: '#F44771',
  remy: '#FEEBEF',
  grandis: '#FFD18B99',
  funGreen: '#006738',
  lightFunGreen: alpha('#006738', 0.08),
  greenLight: '#80B39B',
  seaGreen: '#338560',
  bitterSweet: '#FD675D',
  gin: '#EBF3EF',
  warning: '#FFC32C',
  sunshade: '#FEB02F',
  // Background
  mischka: '#D6D8E2',
  ghostWhite: '#F7F8FC',
  white: '#FFFFFF',
  whisper: '#F5F5FA',
  lightWhisper: '#FBFBFD',
  athensGray: '#E5E8EF',
  // Text & Icon
  tuna: '#343843',
  santasGray: '#A2A6B8',
  flushOrange: '#FF7A00',
  ghost: '#C9CDD9',
  waterloo: '#79819A',
  mineShaft: '#373737',
  comet: '#535869',
  raven: '#6E768F',
  frenchGray: '#BBBEC7',
  // Divider
  catskillWhite: '#E9EDF5',
  geyser: '#D9DEE8'
};
export { colors };